import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { itIT } from "@mui/material/locale";
import "../fontStyle.css"; // Import dei font Google
import {
    teal,
    amber,
    cyan,
    orange,
    green,
    indigo,
    lightBlue,
    yellow,
    lime,
    deepOrange,
    lightGreen,
    grey,
} from "@mui/material/colors";

// Estensione del tema per colori custom
declare module "@mui/material/styles" {
    interface Theme {
        andonStatoPagamento: {
            inLavorazione: string;
            daRichiedere: string;
            inAttesaPagamento: string;
            parzialmentePagato: string;
            pagato: string;
            annullato: string;
        };
        coloriFiltro: {
            attivo: string;
            disattivo: string;
        };
    }

    interface ThemeOptions {
        andonStatoPagamento?: {
            inLavorazione?: string;
            daRichiedere?: string;
            inAttesaPagamento?: string;
            parzialmentePagato?: string;
            pagato?: string;
            annullato?: string;
        };
        coloriFiltro?: {
            attivo?: string;
            disattivo?: string;
        };
    }
}

export const productionTheme = responsiveFontSizes(
    createTheme(
        {
            // CONFIGURAZIONE FONT
            typography: {
                // Font generale per body, body2, paragrafi, ecc.
                fontFamily: [
                    "Lato", // Font principale
                    "Roboto", // Fallback
                    "-apple-system",
                    "BlinkMacSystemFont",
                    '"Segoe UI"',
                    "Arial",
                    "sans-serif",
                ].join(","),

                // Font specifici per elementi particolari
                h1: { fontFamily: "Rubik", fontWeight: 700 },
                h2: { fontFamily: "Rubik", fontWeight: 600 },
                h3: { fontFamily: "Rubik", fontWeight: 600 },
                h4: { fontFamily: "Rubik", fontWeight: 500 },
                h5: { fontFamily: "Rubik", fontWeight: 500 },
                h6: { fontFamily: "Rubik", fontWeight: 500 },
                button: { fontFamily: "Rubik", fontWeight: 500 },
            },

            // CONFIGURAZIONE PALETTE
            palette: {
                mode: "light",
                primary: {
                    main: "#00537f",
                    dark: "#ff6f00",
                },
                secondary: {
                    main: "#cdeeff",
                },
                text: {
                    primary: "#191919",
                    secondary: "#1d4763",
                },
                error: {
                    main: "#FF2222",
                },
                info: {
                    main: "#0289b0",
                },
                success: {
                    main: "#69f0ae",
                },
                divider: "rgba(25,25,25,0.5)",
                background: {
                    default: "#e0e0e0",
                    paper: "#ffffff",
                },
            },

            // CONFIGURAZIONE FORME
            shape: {
                borderRadius: 8,
            },

            // CONFIGURAZIONE COMPONENTI
            components: {
                // BUTTON
                MuiButton: {
                    styleOverrides: {
                        root: {
                            borderRadius: 8,
                            fontWeight: 500,
                            textTransform: "none",
                            padding: "8px 16px",
                        },
                        contained: {
                            boxShadow: "0 4px 8px rgba(0, 83, 127, 0.2)",
                            "&:hover": {
                                boxShadow: "0 6px 12px rgba(0, 83, 127, 0.3)",
                            },
                        },
                        outlined: {
                            borderWidth: "2px",
                            "&:hover": {
                                borderWidth: "2px",
                            },
                        },
                    },
                },
                // CARD
                MuiCard: {
                    styleOverrides: {
                        root: {
                            borderRadius: 8,
                        },
                    },
                },
                // TEXTFIELD
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 8,
                            },
                        },
                    },
                },
            },

            // COLORI CUSTOM
            andonStatoPagamento: {
                inLavorazione: amber[300],
                daRichiedere: indigo[300],
                inAttesaPagamento: lime[300],
                parzialmentePagato: green[100],
                pagato: green[300],
                annullato: grey[300],
            },
            coloriFiltro: {
                attivo: lightGreen["A400"],
                disattivo: teal[100],
            },
        },
        itIT
    )
);